var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGlobalicon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 283,
    height: 266,
    viewBox: "0 0 283 266",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.7158 248.635V254.107",
    stroke: "#005555",
    strokeWidth: 1.25704,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M66.6375 256.425H62.0732",
    stroke: "#005555",
    strokeWidth: 1.25704,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6843 256.425H53.1201",
    stroke: "#005555",
    strokeWidth: 1.25704,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M59.7158 259.077V264.549",
    stroke: "#005555",
    strokeWidth: 1.25704,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M55.167 83.2314V88.7117",
    stroke: "#005555",
    strokeWidth: 1.25704,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M62.0886 91.0215H57.5244",
    stroke: "#005555",
    strokeWidth: 1.25704,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M53.1355 91.0215H48.5713",
    stroke: "#005555",
    strokeWidth: 1.25704,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M55.167 93.6738V99.1541",
    stroke: "#005555",
    strokeWidth: 1.25704,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M253.755 39.4443V44.9166",
    stroke: "#005555",
    strokeWidth: 1.25704,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M260.669 47.2344H256.104",
    stroke: "#005555",
    strokeWidth: 1.25704,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M251.716 47.2344H247.151",
    stroke: "#005555",
    strokeWidth: 1.25704,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M253.755 49.8867V55.359",
    stroke: "#005555",
    strokeWidth: 1.25704,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M64.2637 1.54492V7.01721",
    stroke: "#005555",
    strokeWidth: 1.25704,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M71.1853 9.33496H66.6211",
    stroke: "#005555",
    strokeWidth: 1.25704,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M62.2322 9.33496H57.668",
    stroke: "#005555",
    strokeWidth: 1.25704,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M64.2637 11.9873V17.4596",
    stroke: "#005555",
    strokeWidth: 1.25704,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M139.291 260.599C70.3898 260.504 13.7393 203.781 13.7393 134.872C13.7393 65.8987 70.4934 9.14453 139.467 9.14453C208.44 9.14453 265.194 65.8987 265.194 134.872",
    stroke: "#005555",
    strokeWidth: 1.25704,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M186.446 251.382C226.202 235.157 256.065 199.057 263.425 155.717",
    stroke: "#005555",
    strokeWidth: 1.25704,
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M139.458 260.599C100.483 260.599 68.8916 204.307 68.8916 134.872C68.8916 115.245 71.4167 96.6695 75.9172 80.1172",
    stroke: "#005555",
    strokeWidth: 1.25704,
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M90.0723 45.0689C102.801 22.8452 120.23 9.14453 139.458 9.14453C178.433 9.14453 210.025 65.4367 210.025 134.872",
    stroke: "#005555",
    strokeWidth: 1.25704,
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M90.0723 224.165C102.801 246.389 120.23 260.09 139.458 260.09C178.433 260.09 210.025 203.797 210.025 134.362",
    stroke: "#005555",
    strokeWidth: 1.25704,
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M139.458 9.14453V259.588",
    stroke: "#005555",
    strokeWidth: 1.25704,
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7432 139.324H247.686",
    stroke: "#005555",
    strokeWidth: 1.25704,
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3369 64.5361H243.352",
    stroke: "#005555",
    strokeWidth: 1.25704,
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M92.3096 204.004H135.005",
    stroke: "#005555",
    strokeWidth: 1.25704,
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9473 204.004H67.2988",
    stroke: "#005555",
    strokeWidth: 1.25704,
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M197.566 86.4329C209.66 86.4329 219.463 76.6293 219.463 64.5358C219.463 52.4424 209.66 42.6387 197.566 42.6387C185.473 42.6387 175.669 52.4424 175.669 64.5358C175.669 76.6293 185.473 86.4329 197.566 86.4329Z",
    fill: "#F8B400",
    fillOpacity: 0.17,
    stroke: "#005555",
    strokeWidth: 1.25704,
    strokeMiterlimit: 10
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M139.79 159.765C151.883 159.765 161.687 149.961 161.687 137.868C161.687 125.774 151.883 115.971 139.79 115.971C127.696 115.971 117.893 125.774 117.893 137.868C117.893 149.961 127.696 159.765 139.79 159.765Z",
    fill: "#F8B400",
    fillOpacity: 0.17,
    stroke: "#005555",
    strokeWidth: 1.25704,
    strokeMiterlimit: 10
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9469 225.447C46.0404 225.447 55.8441 215.643 55.8441 203.549C55.8441 191.456 46.0404 181.652 33.9469 181.652C21.8535 181.652 12.0498 191.456 12.0498 203.549C12.0498 215.643 21.8535 225.447 33.9469 225.447Z",
    fill: "#F8B400",
    fillOpacity: 0.17,
    stroke: "#005555",
    strokeWidth: 1.25704,
    strokeMiterlimit: 10
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M265.185 139.324C274.234 139.324 281.57 131.988 281.57 122.939C281.57 113.89 274.234 106.554 265.185 106.554C256.136 106.554 248.8 113.89 248.8 122.939C248.8 131.988 256.136 139.324 265.185 139.324Z",
    fill: "#F8B400",
    fillOpacity: 0.17,
    stroke: "#005555",
    strokeWidth: 1.25704,
    strokeMiterlimit: 10
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 72C17.299 72 22 67.5228 22 62C22 56.4772 17.299 52 11.5 52C5.70101 52 1 56.4772 1 62C1 67.5228 5.70101 72 11.5 72Z",
    fill: "#F8B400",
    fillOpacity: 0.17,
    stroke: "#005555",
    strokeWidth: 1.25704,
    strokeMiterlimit: 10
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M256.5 225C260.642 225 264 221.866 264 218C264 214.134 260.642 211 256.5 211C252.358 211 249 214.134 249 218C249 221.866 252.358 225 256.5 225Z",
    fill: "#F8B400",
    fillOpacity: 0.17,
    stroke: "#005555",
    strokeWidth: 1.25704,
    strokeMiterlimit: 10
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobalicon);
export default __webpack_public_path__ + "static/media/globalicon.66c9c14437fcaa93d7b5c4b4ff30a7d0.svg";
export { ForwardRef as ReactComponent };